class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('select[name="country_code"], select[name="language_code"]')
    };

    this.querySelectorAll('select[name="country_code"]').forEach(item => item.addEventListener('change', this.onItemChange.bind(this)));
    this.querySelectorAll('select[name="language_code"]').forEach(item => item.addEventListener('change', this.onLanguageChange.bind(this)));
  }

  /* Changement de pays/marché */
  onItemChange(event) {
    const form = this.querySelector('form');
    const selectedOption = event.target.value;

    if (selectedOption === "GB") {
      window.location.href = "https://www.soeur.uk";
    }
    else {
      if (form) form.submit();
    }
  }

  /* Changement de langue */
  onLanguageChange(event) {
    console.log('onLanguageChange');
    const form = this.querySelector('form');
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
